import React from 'react';
import ReactDOM from 'react-dom';
import { fetchData } from '../../helpers/base_data_fetcher';
import PriceModal from '../account/components/PriceModal.jsx';
import { getActiveTestVariant } from '../../experiments/helpers/ab_tests';

const mountElement = document.getElementById('seePrices');

export default function examplePriceModal() {
  if (mountElement) {
    Promise.all([
      fetchData('site'),
      fetchData('customer'),
      fetchData('page'),
      fetchData('commerce'),
      // currentProduct={this.props.currentProduct}
    ]).then(([site, customer, page, commerce]) => {
      let hide_one_week_option_experiment = false;
      async function triggerExperiment(active_variant) {
        if (active_variant) {
          hide_one_week_option_experiment = true;
        }
        ReactDOM.render(
          <PriceModal
            currencySymbol={site.currency_symbol}
            subDirectory={site.sub_dir}
            products={commerce.products}
            hide_one_week_option_experiment={hide_one_week_option_experiment}
          />,
          mountElement,
        );
      }

      const hide_one_week_experiment = getActiveTestVariant(
        'main_offerer_upgrade_page_remove_1_week_option_mobile',
      );
      triggerExperiment(hide_one_week_experiment);
    });
  }
}

const modalPriceButton = document.getElementById('modalPriceButton');

if (modalPriceButton) {
  modalPriceButton.addEventListener('click', () => {
    trackEvent({
      category: 'ads',
      action: 'free_bold_options_see_bold_example_post_ad',
    });
  });
}
